(function ($) {
    $(document).ready(function () {
        if (typeof window.currentPageId !== "undefined") {
            checkPrimaryNav();
            //checkTertiaryNav();
            checkLeftNav();
        }
    });

    function checkTertiaryNav() {
        var $item = $('.tertiary').find('#tertiary-' + window.currentPageId);

        if ($item.length > 0) {
            var $firstAnchor = $item.find("a");
            if ($firstAnchor !== null) {
                $firstAnchor.addClass("tertiary__link--active");
            }
        }
    }

    function checkPrimaryNav() {
        var $item = $('.nav').find('#nav-' + window.currentPageId);

        if ($item.length > 0) {
            var $link = $item.find("> a.nav__link");
            if ($link !== null) {
                var topLevelItem = $link.parents(".nav__item");
                topLevelItem.addClass("nav__item--current-section");
                if (topLevelItem.length <= 0) {
                    $('#nav-' + window.parentPageId).addClass("nav__item--current-section");
                }

                $link.addClass("nav__link--active");
            }
        } else {
            // If no parent was directly found we will need to traverse the tree to add the active states for the menu.

            var $liParent = $('#nav-' + window.parentPageId);
            $liParent.addClass("nav__item--current-section");
            $liParent.find('> a.nav__link ').addClass('is-active');
            $liParent.parents(".nav__item").addClass("nav__item--current-section");
            $liParent.parents('.nav__item--1').addClass('is-active');
        }
    }

    function checkLeftNav() {
        var $item = $('.leftNav').find('#leftNav' + window.parentPageId + ', #leftNav-' + window.currentPageId);

        if ($item.length > 0) {

            var $link = $item.find("> a.leftNav__link");
            if ($link !== null) {
                $link.addClass("leftNav__link--active");
                // // Check for parents
                // $link.parents(".left-nav__item").find("> .left-nav__link:not(.left-nav__link--active)").addClass("left-nav__link--selected");
                $link.parents(".leftNav__item").addClass("leftNav__item--current-cat");
            }
        }
    }

})(jQuery);